import React from 'react';
import tw from 'twin.macro'; //eslint-disable-line
import styled from 'styled-components';
import Header, {
  NavLink,
  NavLinks,
  PrimaryLink,
  LogoLink,
  NavToggle,
  DesktopNavLinks,
} from '../headers/light'; // Adjust the import path based on your directory structure

const navLinks = [
  <NavLinks key={1}>
    <NavLink href='/'>Home</NavLink>
    <NavLink href='/about'>About</NavLink>
    <NavLink href='/academic'>Academic</NavLink>
    <NavLink href='/gallery'>Gallery</NavLink>
    <NavLink href='/advertisements'>Advertisements</NavLink>
  </NavLinks>,
  <NavLinks key={2}>
    <PrimaryLink href='/contact'>Contact Us</PrimaryLink>
  </NavLinks>,
];

const StyledHeader = styled(Header)`
  ${tw`pt-4 max-w-none`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-700 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;

const NavBar = () => {
  return <StyledHeader links={navLinks} />;
};

export default NavBar;
